import SmartBookingLinks from "./SmartBookingLinks";

const FallbackDayContent = ({ day, bookingLinks, tripSummary, localServices }) => {
  return (
    <div className="flex flex-col lg:flex-row gap-6">
      {day.image && (
        <div className="lg:w-1/3">
          <img
            src={day.image.url}
            alt={day.title}
            className="w-full h-56 object-cover rounded-xl"
          />
        </div>
      )}
      <div className={day.image ? "lg:w-2/3" : "w-full"}>
        <p className="text-gray-700 leading-relaxed mb-4">{day.description}</p>
        {day.highlights && day.highlights.length > 0 && (
          <div className="mb-4">
            <p className="text-sm font-semibold text-gray-600 mb-2">Highlights:</p>
            <ul className="space-y-1">
              {day.highlights.map((h, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>
                  {h}
                </li>
              ))}
            </ul>
          </div>
        )}

        <SmartBookingLinks
          day={day}
          bookingLinks={bookingLinks}
          tripSummary={tripSummary}
          localServices={localServices}
        />
      </div>
    </div>
  );
};

export default FallbackDayContent;
